import styled from "styled-components";
import { Form } from "formik";

export const Container = styled.div`
  background-color: white;
  border-radius: 10px;
  width: auto;
`;

export const Header = styled.div`
  padding: 18px 25px;
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

export const Title = styled.span`
  font-size: 20px;
  font-family: ${({ theme }) => theme.font.mangueira.bold};
  color: ${({ theme }) => theme.colors.blue};
`;

export const BtnClose = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 3px;
  background-color: transparent;
  border: none;

  & svg {
    color: ${({ theme }) => theme.colors.blue};
    font-size: 18px;
  }
`;

export const Content = styled.div`
  padding: 0 25px 18px;
  display: flex;
  flex-direction: column;
`;

export const ContentUpdateEmail = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
`;

export const Label = styled.div`
  display: flex;
  gap: 5px;

  & span {
    font-family: ${({ theme }) => theme.font.mangueira.medium};
    font-size: 16px;
    line-height: 1;
  }

  @media (max-width: 768px) {
    flex-direction: column;
  }
`;

export const ButtonEdit = styled.button`
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 10px;
  background-color: transparent;
  border: none;

  & span {
    font-size: 16px;
    line-height: 1;
    color: #808495;
  }

  & svg {
    font-size: 16px;
    color: #808495;
  }
`;

export const FormContainer = styled(Form)`
  width: 100%;
`;

export const ContentField = styled.div`
  display: grid;
  grid-template-columns: 2fr 1fr;
  grid-gap: 15px;
  margin-bottom: 20px;

  @media (max-width: 768px) {
    grid-template-columns: 1fr;
    grid-gap: 2px;
    margin-bottom: 10px;
  }

  & div:first-of-type {
    margin-bottom: 0;
  }
`;

export const Field = styled.div`
  margin-bottom: 20px;
  display: flex;
  flex-direction: column;
`;

export const Footer = styled.div`
  padding: 18px 25px;
  display: flex;
  justify-content: space-between;
  width: 100%;
`;
